import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { trackedServiceCall } from '@/apiCalls/uniqueIDTransferHelper';
import { setVehicle } from '@/context/borrower';
import { store } from '@/context/store';
import { getGlassAssetType } from '@/utils/glassGuideHelpers';

import { IVehicleReturn } from './lookupNvicTypes';

export async function lookupNvic(partnerId: string): Promise<void> {
    const state = store.getState();
    const stateNvic = state.borrowerReducer.vehicle.nvic;
    const stateVehicle = state.borrowerReducer.vehicle;
    const assetType = state.borrowerReducer.vehicle.assetType;
    const disabledGlassesGuideVinLookup =
        state.displayReducer.partner.disabledGlassesGuideVinLookup;

    if (!stateNvic) return;

    if (disabledGlassesGuideVinLookup) {
        console.log('Glasses guide NVIC lookup is disabled for this brand');
        return;
    }

    const url = `/api/asset/select/${partnerId}/${getGlassAssetType(
        assetType
    )}/nvic/${stateNvic}`;

    const data = await trackedServiceCall('assetLookupNvic', () =>
        postUrl<IVehicleReturn>(url, { billingContext: buildBillingContext() })
    );

    if (!data) return;

    const {
        make,
        model,
        vin,
        nvic,
        variant,
        buildYear,
        glassValuation,
        description,
        bodyType,
    } = data;

    const isVehicleKnown = glassValuation ? true : false;

    store.dispatch(
        setVehicle({
            ...stateVehicle,
            make,
            model,
            vin,
            nvic,
            variant,
            buildYear,
            glassValuation,
            description,
            bodyType,
            isVehicleKnown,
        })
    );
}
